<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :title_size="18"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>
        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="show_download_pdf_btn"
            >
                <template #table_description>
                    <span>
                        說明："--"標示，顯示該欄位無資料。<br>
                        {{ $t('__monitor.min_10_gust_annotation') }}<br>
                        {{ $t('__monitor.hour_1_gust_annotation') }}<br>
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax, monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "../../../config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "../qpe_datatable.vue";
    
    export default {
        name: 'ScenicAreaMonitor',

        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable,
        },

        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                require: true,
                default: -1
            },
            table_data: {
                type: Array,
                default() {
                    return []
                }
            },
            show_download_pdf_btn: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                header: [],
                immutable_table_data: [],
                error_text: '',
                search: '',

                should_show_raw_html_header: ['警示'],

                TABLE_VALUE_TEXT_MAPPING: TABLE_VALUE_TEXT_MAPPING,
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },
        },

        watch: {
            immutable_table_data: {
                handler() {
                    this.$emit('transfer_immutable_table_data', this.immutable_table_data)
                },
                deep: true
            },
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.header = header;
            },
        },
    }
</script>